export { default as LockIcon } from './ic__outline_lock.svg';
